import script from "./BodySubFeaturesMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./BodySubFeaturesMobile.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./BodySubFeaturesMobile.vue?vue&type=style&index=0&id=db00edf4&module=featuresMobile&lang=css"
cssModules["featuresMobile"] = style0

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__